/* eslint-disable no-new no-alert, no-console, no-unused-vars, no-undef */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import VueCookie from "vue-cookie";
import VueResource from "vue-resource";
import BootstrapVue from "bootstrap-vue";
import router from "./router";
import vuexI18n from "vuex-i18n";
import translationsEn from "./lang/translationEn.json";
import translationsFr from "./lang/translationFr.json";
import vuexIdentity from "@/identity";
import VueHead from "vue-head";
import Datatable from "@/_utilities/vue2-datatable/main.js";
import vSelect from "vue-select";
import Autocomplete from "vue2-autocomplete-js";
import Datepicker from "vuejs-datepicker";
import pdf from "vue-pdf";

Vue.component("datepicker", Datepicker);
Vue.component("pdf", pdf);
Vue.component("autocomplete", Autocomplete);
Vue.component("v-select", vSelect);
//import Datatable from 'vue2-datatable-component'
Vue.use(Datatable);
Vue.use(Vuex);
const i18nStore = new Vuex.Store();
Vue.use(vuexI18n.plugin, i18nStore);

const identityStore = new Vuex.Store();
Vue.use(vuexIdentity.plugin, identityStore);

Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(BootstrapVue);

// Vue.http.options.root = "http://api.nano.dev.volcan.design:8093/api";

//Test
//Vue.http.options.root = "http://api.nano.mv.dsi.loc/api";
// Vue.http.options.root = "http://api.nano.dev.dsi.loc/api";
// Vue.http.options.root = "http://api.nano.dev.dsi.loc/api";
// Vue.http.options.root = "http://localhost:1182/api";
//LIVE
Vue.http.options.root = "/proxy.php";
// Vue.http.options.root = "https://api.nanocollection.com/api";
// Vue.http.options.root = "http://apitest.nanocollection.com:442/api";
//Vue.http.options.root = "http://api-test.nano.dev.volcan.design:8092/api";

var lang = navigator.language || navigator.userLanguage;
Vue.i18n.set(lang.indexOf("en") >= 0 ? "en" : "fr");
//setting language
Vue.i18n.add("en", translationsEn);
Vue.i18n.add("fr", translationsFr);

//setting meta head
Vue.use(VueHead);
Vue.use(VueRouter);

const App = () => import("@/App");

new Vue({
  el: "#app",
  router,
  template: "<App/>",
  render: h => h(App),
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js